module.exports = __webpack_public_path__ + "img/161.a4cae701.jpg";